export enum SiteSlug {
    RP = "rynekpierwotny",
    GH = "gethome",
    KM = "konto-mieszkaniowe"
}
